@keyframes wbagent-row-shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

.wbagent-row-shimmer {
  background-image: linear-gradient(
    90deg,
    #b1b4b9 0%,
    #b1b4b9 40%,
    #2b3038 50%,
    #b1b4b9 60%,
    #b1b4b9 100%
  );
  background-size: 200% 100%;
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  animation: wbagent-row-shimmer 2.2s linear infinite;
}

.dark .wbagent-row-shimmer,
[data-mode='dark'] .wbagent-row-shimmer {
  background-image: linear-gradient(
    90deg,
    #565c66 0%,
    #565c66 40%,
    #dfe0e2 50%,
    #565c66 60%,
    #565c66 100%
  );
  background-size: 200% 100%;
}
